module.exports = __webpack_public_path__ + "static/media/html5.9f45c653.svg";